module.exports = "/assets/89106bfefd73ae92daa5b5e248be78f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SS.png
// module id = 1832
// module chunks = 0